// Ticket type a parking zone assigns to its tickets (BEP-2064).
// Mirrors TicketViolationType.fromParkingZoneViolationType in beppo-backend. Change both together.
const ZONE_TO_TICKET_VIOLATION_TYPE = {
  CH_ZPO: "CH_PARKING_VIOLATION_ZPO",
  CH_NON_ZPO: "CH_PARKING_VIOLATION_NON_ZPO",
  AT_ZPO: "AT_PARKING_VIOLATION_ZPO",
  AT_NON_ZPO: "AT_PARKING_VIOLATION_NON_ZPO",
  DE_NON_ZPO: "DE_PARKING_VIOLATION_NON_ZPO",
};

export const ticketViolationTypeForZone = (parkingViolationType) =>
  ZONE_TO_TICKET_VIOLATION_TYPE[parkingViolationType];
